package com.exura.features.demosets.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName


@Serializable
@JsName("DemoSetPlanFacet")
data class DemoSetPlanFacet(

    @JsName("title")
    val title: String,

    @JsName("description")
    val description: String,

    @JsName("imageUrl")
    val imageUrl: String?,

    @JsName("planDuration")
    val planDuration: Int,

    @JsName("numberInstruction")
    val numberInstruction: Int,

    @JsName("numberPersistent")
    val numberPersistent: Int,

    @JsName("numberQuestion")
    val numberQuestion: Int,

    @JsName("numberFloating")
    val numberFloating: Int,
)
